import React from "react";
import { NavLink } from "react-router-dom";
import { 
  FiGrid,
  FiPlusCircle, 
  FiClipboard, 
  FiStar,
  FiSettings,
  FiLogOut,
  FiUser
} from "react-icons/fi";
import logo from "../assets/images/achal_logo.png";

const UserSidebar = () => {
  const username = localStorage.getItem("username") || "User";
  const fullName = localStorage.getItem("full_name") || username;

  const menu = [
    { name: "Dashboard", icon: <FiGrid />, path: "/user/dashboard" },
    { name: "Raise New Issue", icon: <FiPlusCircle />, path: "/user/raise-issue" },
    { name: "My Raised Tickets", icon: <FiClipboard />, path: "/user/my-tickets" },
    { name: "Reviews & Ratings", icon: <FiStar />, path: "/user/reviews" },
    { name: "Profile & Settings", icon: <FiSettings />, path: "/user/settings" },
  ];

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to sign out?")) {
      localStorage.clear();
      window.location.href = "/";
    }
  };

  return (
    <div style={styles.sidebar}>
      {/* 🏛️ PREMIUM LOGO SECTION */}
      <div style={styles.logoSection}>
        <img 
          src={logo} 
          alt="Achal Jewels" 
          style={styles.mainLogo} 
        />
        <div style={styles.logoDivider}></div>
        <p style={styles.subLogo}>Service Portal</p>
      </div>

      {/* 👤 USER PROFILE BADGE */}
      <div style={styles.userCard}>
        <div style={styles.avatar}>
          <FiUser size={18} color="#D4AF37" />
        </div>
        <div style={styles.userInfo}>
          <div style={styles.userName}>{fullName}</div>
          <div style={styles.userRole}>Employee Portal</div>
        </div>
      </div>

      {/* 🧭 NAVIGATION MENU */}
      <div style={styles.menu}>
        {menu.map((item, index) => (
          <NavLink
            key={index}
            to={item.path}
            style={({ isActive }) => ({
              ...styles.item,
              ...(isActive ? styles.active : styles.nonActive),
            })}
          >
            {({ isActive }) => (
              <>
                <span style={{ ...styles.icon, color: isActive ? "#1B2559" : "#D4AF37" }}>
                  {item.icon}
                </span>
                <span>{item.name}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>

      {/* 🚪 LOGOUT SECTION */}
      <div style={styles.bottomSection}>
        <div style={styles.logoutBtn} onClick={handleLogout}>
          <FiLogOut style={styles.icon} />
          <span>Secure Sign Out</span>
        </div>
      </div>
    </div>
  );
};

const styles = {
  sidebar: {
    width: "280px",
    height: "100vh",
    background: "#FFFFFF",
    padding: "36px 20px",
    position: "fixed",
    display: "flex",
    flexDirection: "column",
    boxShadow: "10px 0 40px rgba(0,0,0,0.02)",
    zIndex: 100,
    top: 0,
    left: 0,
    boxSizing: "border-box",
    borderRight: "1px solid #F0F2FA",
  },
  logoSection: {
    marginBottom: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flexShrink: 0,
  },
  mainLogo: {
    height: "70px", 
    width: "auto",
    objectFit: "contain",
  },
  logoDivider: {
    width: "40px",
    height: "2px",
    background: "#D4AF37",
    margin: "12px 0 8px 0",
    borderRadius: "2px",
    opacity: 0.6
  },
  subLogo: { 
    fontSize: "10px", 
    color: "#94A3B8", 
    fontWeight: "800", 
    textTransform: "uppercase", 
    letterSpacing: "3px"
  },
  userCard: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 14px",
    background: "#F8FAFC",
    borderRadius: "16px",
    border: "1px solid #F0F2FA",
    marginBottom: "24px",
  },
  avatar: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    background: "#FFF",
    border: "1.5px solid #E2E8F0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  userInfo: {
    minWidth: 0,
    flex: 1,
  },
  userName: {
    fontSize: "13px",
    fontWeight: "800",
    color: "#1B2559",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  userRole: {
    fontSize: "10px",
    fontWeight: "600",
    color: "#94A3B8",
    marginTop: "2px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  menu: { 
    display: "flex", 
    flexDirection: "column", 
    gap: "8px", 
    flex: 1,
    overflowY: "auto",
  },
  item: { 
    display: "flex", 
    alignItems: "center", 
    gap: "14px", 
    padding: "14px 18px", 
    borderRadius: "16px", 
    cursor: "pointer", 
    transition: "0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    fontSize: "14px",
    textDecoration: "none",
    fontWeight: "700",
  },
  active: { 
    background: "#F4F7FE", 
    color: "#1B2559", 
    boxShadow: "0 4px 15px rgba(0,0,0,0.03)",
    borderLeft: "4px solid #1B2559",
  },
  nonActive: { 
    color: "#8F9BBA", 
    background: "transparent",
  },
  icon: { 
    fontSize: "18px",
    display: "flex",
    alignItems: "center",
  },
  bottomSection: {
    paddingTop: "20px",
    borderTop: "1px solid #F4F7FE",
  },
  logoutBtn: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px 18px",
    borderRadius: "16px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "700",
    color: "#EE5D50",
    background: "#FFF5F5",
    transition: "0.2s",
  },
};

export default UserSidebar;
